module.exports = __webpack_public_path__ + "MarkerSelected.1248c1aca55141e7e81133eab9102087.png";